export default {
  'pages.propertyAgent.title': '房屋中介管理',
  'pages.propertyAgent.subTitle': '管理房屋中介信息和账户',
  'pages.propertyAgent.detailTitle': '中介详情',
  'pages.propertyAgent.basicInfo': '基本信息',
  'pages.propertyAgent.accountInfo': '账户信息',
  'pages.propertyAgent.otherInfo': '其他信息',
  'pages.propertyAgent.name': '中介姓名',
  'pages.propertyAgent.namePlaceholder': '请输入中介姓名',
  'pages.propertyAgent.company': '中介公司',
  'pages.propertyAgent.companyPlaceholder': '请输入中介公司',
  'pages.propertyAgent.type': '中介类型',
  'pages.propertyAgent.typePlaceholder': '请选择中介类型',
  'pages.propertyAgent.phone': '联系电话',
  'pages.propertyAgent.phonePlaceholder': '请输入联系电话',
  'pages.propertyAgent.email': '邮箱',
  'pages.propertyAgent.emailPlaceholder': '请输入邮箱',
  'pages.propertyAgent.username': '用户名',
  'pages.propertyAgent.usernamePlaceholder': '请输入用户名',
  'pages.propertyAgent.password': '密码',
  'pages.propertyAgent.passwordPlaceholder': '请输入密码',
  'pages.propertyAgent.confirmPassword': '确认密码',
  'pages.propertyAgent.confirmPasswordPlaceholder': '请再次输入密码',
  'pages.propertyAgent.status': '状态',
  'pages.propertyAgent.remark': '备注',
  'pages.propertyAgent.remarkPlaceholder': '请输入备注信息',
};
